<script setup lang="ts">
    import { useAttrs, ref, nextTick, computed } from 'vue';
    let key = ref(0);
    let input = ref()
    let attrs = useAttrs();
    let min = computed(()=> {
        return attrs.min ? parseFloat(attrs.min) : -Infinity;
    });

    let max = computed(()=> {
        return attrs.max ? parseFloat(attrs.max) : Infinity;
    });

    let step = computed(()=> {
        return attrs.step ? parseFloat(attrs.step) : 1;
    });

    const [ model, modifiers] = defineModel({
        set(value) {
            if(modifiers.natural) {
                value = Math.max(0, value);
            }
            if(modifiers.integer) {
                value = Math.round(value);
            }
            if(modifiers.float) {
                value = parseFloat(value);
            }
            if(modifiers.whole){
                value = Math.floor(value);
            }

            if( step.value !== 1) {
                value = Math.round(value / step.value) * step.value;
            }
            if(value < min.value) {
                value = min.value;
            }
            if(value > max.value) {
                value = max.value;
            }

            let inputHasFocus = document.activeElement === input.value;
            key.value++;
            nextTick(() => {
                if(inputHasFocus) {
                    input.value.focus();
                }
            });

                
            return value;
        },
    });

</script>
<template>
    <input type="text" v-model.lazy="model" v-bind="useAttrs()" :key="key" ref="input"/>
</template>